// Data/Tables/Reports/WalkInCustomers/tables.js
const tables = [
  {
    name: "Invoice No",
  },
  {
    name: "Date",
  },
  {
    name: "Total Amount",
  },
  {
    name: "Paid Amount",
  },
  {
    name: "Outstanding",
  },
  {
    name: "Payment Status",
  },
  {
    name: "Delivery Status",
  },
  {
    name: "Payment Methods",
  },
];

export default tables;